// build up a list of classes to apply to the button
export function getButtonClass(props) {
   if (props.styleType.toLowerCase() === "text-only") return [`text-${props.size.toLowerCase()}`, "underline"];

   return [
      `color-${props.isDisabled ? "disabled" : props.color.toLowerCase()}`,
      `variant-${props.styleType.toLowerCase()}`,
      `size-${props.size.toLowerCase()}`,
      `rounded-${props.roundedEdges}`,
   ];
}

// common CTA button methods shared between Card buttons and Page Section buttons
export function onCTAClick(action, intercom) {
   if (action === "intercom") {
      intercom.open();
   }
}
